@for (message of activeMessages$ | async; track message) {
  <div class="message-box">
    <div class="message">
      <strong class="message-title">New message from Administrator</strong>
      <p class="message-conent">{{ message.message }}</p>
      <button class="message-close" (click)="markMessageAsRead(message)">&times;</button>
    </div>
  </div>
}